














import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'

import WholeDisplayImage from '@/components/shared/atoms/Image/WholeDisplayImage'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'

export default Vue.extend({
  components: {
    WholeDisplayImage,
    LinkButton
  },
  props: {
    voiceId: {
      type: String,
      required: true
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        voiceRepository: this.$voiceRepository,
        id: this.voiceId
      })
    }
  },
  mounted() {
    if (this.presenter.voice) {
      const html = document.getElementById('innerHtmlTarget')
      if (html) {
        html.innerHTML = this.presenter.voice.props.content
      }
    }
  }
})
